import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormFieldArrayStyles = makeStyles()((theme: Theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
	},
	item: {
		display: "flex",
		flexDirection: "row",
	},
	button: {
		alignSelf: "center",
		marginLeft: theme.spacing(1),
		"&:disabled": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
		"& svg": {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
		},
	},
	noFields: {
		flex: 1,
		justifyContent: "center",
	},
}));
